import { render, staticRenderFns } from "./AreaListOption.vue?vue&type=template&id=61cd2590"
import script from "./AreaListOption.vue?vue&type=script&lang=js"
export * from "./AreaListOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports